module.exports = __webpack_public_path__ + "static/media/loader.532da922.gif";